import { TaskChooseOrganization, TaskResetPassword, TaskSetupMFA } from '@clerk/react-router';
import type { ComponentType } from 'react';
import { paths } from '~/routing/routes';
import { readSessionTaskCompletionTarget, type SessionTaskKey } from '~/routing/sessionTaskHandoff';

export type SessionTask = SessionTaskKey;

const TASK_COMPONENTS: Record<SessionTask, ComponentType<{ redirectUrlComplete: string }>> = {
  'choose-organization': TaskChooseOrganization,
  'reset-password': TaskResetPassword,
  'setup-mfa': TaskSetupMFA,
};

export const SessionTaskPage = ({ task }: { task: SessionTask }) => {
  const TaskComponent = TASK_COMPONENTS[task];
  const completionTarget = readSessionTaskCompletionTarget() ?? paths.publicAuth.authComplete;

  return (
    <main className="flex min-h-screen items-center justify-center bg-primary-t-950 px-4">
      <TaskComponent redirectUrlComplete={completionTarget} />
    </main>
  );
};
